import { createFileRoute } from '@tanstack/react-router'
import { Members } from '@/components/settings-route/user/members/index.jsx'

export const Route = createFileRoute('/_auth/settings/users/members')({
  component: Members,
})
